import { isArray } from 'util';
import { ToolTemplateTool } from '../tool-template-tool';
import { ToolBuilder } from './tool.builder';

export class ToolTemplateToolBuilder {
  static fromJson(json) {
    return (json)
      ? new ToolTemplateTool(
        json.hash,
        json.orderNumber,
        ToolBuilder.fromJson(json.tool),
        ToolBuilder.buildToolHolderFromJson(json.toolHolder),
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(ToolTemplateToolBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/tool-template-tool.builder.ts